import { CLEAR_MESSAGE, UPDATE_MESSAGE } from 'constants/system';

const initialState = {
  messageCount: '1', //消息数量
  getMsg: false, //消息数量
  switchEn: '', //切换中英文
};

const message = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_MESSAGE: return {
      ...state,
      messageCount: '1',
      getMsg: false,
      switchEn: '',
    };
    case UPDATE_MESSAGE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
};

export default message;
